// store/thunks/auth/verifyRecoveryOtpThunk.ts
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { RecoveryVerificationDTO } from '@/types/DTOs';
import { sendRecoveryTwoFactorThunk } from '@/store/thunks/auth/sendRecoveryTwoFactorThunk';
import { isAutoPhoneVerificationOrganizationToken } from '@/store/utils/jwtDecoder';

export const verifyRecoveryOtpThunk = createAppAsyncThunk<
  RecoveryVerificationDTO,
  { emailAddress: string; code: string },
  { rejectValue: { message: string } }
>(
  'auth/verifyRecoveryOtpThunk',
  async ({ emailAddress, code }, { dispatch, extra: { authService }, rejectWithValue }) => {
    try {
      const result = await authService.verifyRecoveryOtp({ emailAddress, code });

      const recoveryToken = String(result.recoveryToken);
      if (!isAutoPhoneVerificationOrganizationToken(recoveryToken)) {
        const sendResult = await dispatch(sendRecoveryTwoFactorThunk({ recoveryToken }));
        if (!sendRecoveryTwoFactorThunk.fulfilled.match(sendResult)) {
          return rejectWithValue({
            message: sendResult.payload?.message ?? 'Failed to send recovery two-factor code',
          });
        }
      }

      return result;
    } catch (caught) {
      const message = caught instanceof Error ? caught.message : 'Failed to verify recovery code';
      return rejectWithValue({ message });
    }
  }
);
